<template>
  <section>
    <div v-if="lang['nps_scoring_new']" class="nps_page">
      <section class="mt-4">
        <div class="container">
          <div>
            <div>
              <ItemOfVouchers icon="nps-smile" color="#56e068" :label="lang['nps_scoring_new'].SFS_LANG_ROW_1" border />
            </div>
            <div v-if="airline.params && !airline.params.nps_option" class="ws-textbox my-4">
              {{ lang['nps_scoring_new'].SFS_LANG_ROW_6 }}
            </div>
            <div v-else class="ws-textbox my-4">
              <span v-if="pax.nps_detail && pax.nps_detail.comment">
                {{ lang['nps_scoring_new'].SFS_LANG_ROW_7 }}<br />
                {{ lang['nps_scoring_new'].SFS_LANG_ROW_8 }}
              </span>
              <span v-else v-html="replaceStr(lang['nps_scoring_new'].SFS_LANG_ROW_2, ['<airline>'], [airline.name])"></span>
            </div>
            <div v-if="airline.params && airline.params.nps_option == 1 && !pax.nps_detail" class="mb-4">
              <ListFlightInfo :flight-legs="flightLegs" />
            </div>
            <div v-if="airline.params && airline.params.nps_option == 1">
              <div v-if="!pax.nps_detail" class="score-and-feedback">
                <div class="ws-textbox">
                  <div>
                    <NpsScore @handleChangeScore="changeScore" />
                  </div>
                  <div class="mt-4">
                    <div class="d-flex justify-content-between">
                      <span>
                        {{ lang['nps_scoring_new'].SFS_LANG_ROW_3 }}
                      </span>
                      <span> {{ comment.length }}/{{ maxCommentLength }} </span>
                    </div>
                    <div class="input-feedback">
                      <textarea
                        v-model="comment"
                        rows="5"
                        class="comment form-control mb-3"
                        :placeholder="lang['nps_scoring_new'].SFS_LANG_ROW_4 + '...'"
                        @input="assertMaxChars()"
                      ></textarea>
                      <div class="text-center">
                        <input
                          class="submit ws-btn hd-normal-btn-background-color hd-normal-btn-color"
                          type="button"
                          :disabled="score == null || comment == ''"
                          :value="lang['nps_scoring_new'].SFS_LANG_ROW_5"
                          @click="storeNps()"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import '@/assets/scss/modules/NpsPage.scss'
import NpsScore from '@/components/NpsScore/index'
import FlightInfo from '@/components/FlightInfo/index'
import ListFlightInfo from '@/components/ListFlightInfo/index'
import ItemOfVouchers from '@/components/ItemOfVouchers/index'
import { mapGetters } from 'vuex'
import { replaceStr } from '@/utils/helper'

export default {
  name: 'NpsPage',
  components: { NpsScore, FlightInfo, ListFlightInfo, ItemOfVouchers },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      numbersOne: [0, 1, 2, 3, 4, 5],
      numbersTwo: [6, 7, 8, 9, 10],
      comment: '',
      score: 8,
      maxCommentLength: 500
    }
  },
  computed: {
    ...mapGetters({
      flight: 'Flight/Flight',
      flightLegs: 'Flight/flightLegs'
    })
  },
  mounted() {
    this.$store.dispatch('Flight/getFlight')
  },
  methods: {
    replaceStr,
    storeNps: function () {
      if (this.score === null || !this.comment) {
        this.$swal('Please choose score and comment before submit')
        return
      }
      let npsInfo = {
        passenger_id: this.pax.id,
        score: this.score,
        comment: this.comment,
        internal_comment_id: this.internalCmtId
      }
      this.$store.dispatch('NpsPage/storeNpsInfo', npsInfo).then((response) => {
        if (response.success) {
          location.reload()
        }
      })
    },
    assertMaxChars: function () {
      if (this.comment.length >= this.maxCommentLength) {
        this.comment = this.comment.substring(0, this.maxCommentLength)
      }
    },
    changeScore: function (score) {
      this.score = score
    }
  }
}
</script>
